import React, { useContext, useEffect, useState } from "react";
import { DataTable } from "../../Common/Controls/Controls";
import ModalUltimos7 from "./ModalUltimos7/ModalUltimos7"

const Gestiones = ({ setCurrentRow, setShowModalEdicion, id, datatable,ultimas7 }) => {
  const [showModalUltimas7, setShowModaUltimas7] = useState(false);

  return (
    <>
      <div className="AcreditadoDetalleDataTable_header">
        <div className="AcreditadosDetalleTitleTable">Gestiones este mes</div>
        <div className="AcreditadosDetalleButtons">
          <button className="btnUltimas7Gestiones" onClick={()=>setShowModaUltimas7(true)}>
            Últimas 7 gestiones IBCEES
          </button>
          <button
            className="btnNuevaGestion"
            onClick={() => {
              setCurrentRow({
                GestionId: 0,
                AcreditadoId: id,
                TipoGestionId: 0,
                GesGBFechaRegistro: new Date(),
                ValoracionId: 0,
                TipoComentario:""
              });
              setShowModalEdicion(true);
            }}
          >
            Registrar nueva gestión
          </button>
        </div>
      </div>
      <DataTable hover data={datatable} className="mdbDataTableAcreditados" />
      {showModalUltimas7 && (
        <ModalUltimos7
          setShow={setShowModaUltimas7}
          show={showModalUltimas7}
          ultimas7={ultimas7}
        />
      )}
    </>
  );
};

export default Gestiones;
